import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export const PaymentModeOptions: DropdownOptionType[] = [
  { value: 'COD', display: 'COD' },
  { value: 'Pickup', display: 'Pickup' },
  { value: 'Prepaid', display: 'Prepaid' },
  // { value: 'REPL', display: 'REPL' },
];

export const ShippingModeOptions: DropdownOptionType[] = [
  { value: 'Surface', display: 'Surface' },
  { value: 'Express', display: 'Express' },
];

export const PickupLocationTypeOptions: DropdownOptionType[] = [
  { value: 'PARICOURIER SURFACE', display: 'PARI COURIER SURFACE' },
];

export const delhiveryInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  pickup_location: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Pickup location is required'),
  payment_mode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Payment mode is required'),
  shipping_mode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Shipping mode is required'),
});

export interface delhiveryInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  pickup_location: string;
  payment_mode: string;
  shipping_mode: string;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: delhiveryInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'delhivery';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }
  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
